import React from "react";

import styles from "~/pages/CharacterSheet/widgets/PointTracker/PointTracker.module.scss";

export interface PointTrackerProps {
  current: number;
  target: number;
}

/**
 * PointTracker widget for displaying stat point allocation.
 * Shows current total vs target with visual indicator when balanced.
 */
const PointTracker: React.FC<PointTrackerProps> = ({ current, target }) => {
  const isBalanced = current === target;

  return (
    <div className={styles.pointTracker}>
      <span className={styles.pointLabel}>Total:</span>
      <span
        className={`${styles.pointValue} ${isBalanced ? styles.balanced : ""}`}
      >
        {current}
      </span>
    </div>
  );
};

export default PointTracker;
